import React from "react";
import ConatactUs from "../Components/Other/ConatactUs";

const ContactUsPage = () => {
  return <ConatactUs />;
};

export default ContactUsPage;
